import { PaymentMethodCreateParams } from '@stripe/stripe-js/types/api'

import { BillingAddress, CountryCode, Nil, User } from '../../../types'
import { getPersonString } from '../../../utils'

export const billingAddressToStripeFormat = (
  client: User | Nil,
  billingAddress: BillingAddress,
) => ({
  name: getPersonString(client),
  email: client?.email || null,
  phone: client?.mobilePhone || null,
  address: {
    city: billingAddress?.city,
    country: billingAddress?.country,
    line1: billingAddress?.address || billingAddress?.street,
    line2: billingAddress?.suite || billingAddress?.apartmentNumber,
    postal_code: billingAddress?.zip,
    state: billingAddress?.state,
  },
})

export const stripeFormatToBillingAddress = (
  billingDetails: PaymentMethodCreateParams.BillingDetails.Address,
): BillingAddress => ({
  city: billingDetails?.city,
  country: billingDetails?.country as CountryCode,
  address: billingDetails?.line1,
  street: billingDetails?.line1,
  suite: billingDetails?.line2,
  zip: billingDetails?.postal_code, // eslint-disable-line camelcase
  state: billingDetails?.state,
})
